import { render, staticRenderFns } from "./monitorAnxun.vue?vue&type=template&id=58ec8a06&scoped=true"
import script from "./monitorAnxun.vue?vue&type=script&lang=js"
export * from "./monitorAnxun.vue?vue&type=script&lang=js"
import style0 from "./monitorAnxun.vue?vue&type=style&index=0&id=58ec8a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec8a06",
  null
  
)

export default component.exports